import { requestBuilder } from '../../http/RequestBuilder';

const useUpdateMembershipScheduledDiscoveryCall = requestBuilder.mutation<
    null,
    null,
    { userId: string }
>({
    endpoint: ({ userId }) =>
        `/api/user/${userId}/update-scheduled-discovery-call`,
    method: 'POST',
});

export default useUpdateMembershipScheduledDiscoveryCall;
